import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class ConfiguracionService {

    private _httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private readonly _http: HttpClient) {}

    // MANTENIMIENTO DISEÑO DE ETIQUETAS
    public getDisenyoEtiquetas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/DisenyoEtiqueta/GetAllConFiltro', filters);
    }

    public getDisenyoEtiqueta(disenyoEtiquetaId) {
        return this._http.get<any>(environment.apiEndpoint + '/DisenyoEtiqueta/GetById?disenyoEtiquetaId=' + disenyoEtiquetaId);
    }

    public createDisenyoEtiqueta(disenyoEtiqueta) {
        return this._http.post<any>(environment.apiEndpoint + '/DisenyoEtiqueta', disenyoEtiqueta);
    }

    public updateDisenyoEtiqueta(disenyoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint + '/DisenyoEtiqueta', disenyoEtiqueta);
    }

    public deleteDisenyoEtiqueta(disenyoEtiquetaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/DisenyoEtiqueta/?disenyoEtiquetaId=' + disenyoEtiquetaId);
    }

    public asociarDisenyoEtiqueta(imagen) {
        return this._http.post<any>(environment.apiEndpoint + '/DisenyoEtiqueta/AsociaDisenyoEtiquetaBlob', imagen);
    }

    public deleteRefereciaDisenyoEtiqueta(disenyoEtiquetaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/DisenyoEtiqueta/DeleteReferenciaBlob/?disenyoEtiquetaId='
            + disenyoEtiquetaId);
    }

    // MANTENIMIENTO GRUPOS DE ETIQUETAS
    public getGruposEtiquetas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAllConFiltro', filters);
    }

    public getGrupoEtiqueta(grupoEtiquetaId) {
        return this._http.get<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetById?grupoEtiquetaId=' + grupoEtiquetaId);
    }

    public createGrupoEtiqueta(grupoEtiqueta) {
        return this._http.post<any>(environment.apiEndpoint + '/GrupoEtiqueta', grupoEtiqueta);
    }

    public updateGrupoEtiqueta(grupoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint + '/GrupoEtiqueta', grupoEtiqueta);
    }

    public deleteGrupoEtiqueta(grupoEtiquetaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/?grupoEtiquetaId=' + grupoEtiquetaId);
    }


    // FORMATO ETIQUETA

    public getFormatosEtiqueta(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/FormatoEtiqueta/GetAllConFiltro', filters);
    }
    public getFormatoEtiqueta(formatoEtiquetaId) {
        return this._http.get<any>(environment.apiEndpoint + '/FormatoEtiqueta/GetById?formatoEtiquetaId=' + formatoEtiquetaId);
    }

    public createFormatoEtiqueta(formatoEtiqueta) {
        return this._http.post<any>(environment.apiEndpoint + '/FormatoEtiqueta', formatoEtiqueta);
    }

    public updateFormatoEtiqueta(formatoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint + '/FormatoEtiqueta', formatoEtiqueta);
    }

    public deleteFormatoEtiqueta(formatoEtiquetaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/FormatoEtiqueta/?formatoEtiquetaId=' + formatoEtiquetaId);
    }

    public asociarFormatoEtiqueta(archivo) {
        return this._http.post<any>(environment.apiEndpoint + '/FormatoEtiqueta/AsociaFormatoEtiquetaBlob', archivo);
    }

    // CONFIGURACIÓN FORMATO ETIQUETA
    public getConfiguracionFormatoEtiqueta() {
        return this._http.get<any>(environment.apiEndpoint + '/ConfiguracionFormatoEtiqueta/GetAll');
    }

    // CONFIGURADOR CONSUMOS

    public getConfiguracionesConsumos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/ConsumoIntegracionConfiguracion/GetAllConFiltro', filters);
    }

    public getConfiguradorConsumo(configuradorConsumoId) {
        return this._http.get<any>(environment.apiEndpoint + '/ConsumoIntegracionConfiguracion/GetById/?consumoIntegracionConfiguracionId=' + configuradorConsumoId);
    }

    public createConfiguradorConsumo(configuradorConsumo) {
        return this._http.post<any>(environment.apiEndpoint + '/ConsumoIntegracionConfiguracion', configuradorConsumo);
    }

    public deleteConfiguradorConsumo(configuradorConsumoId) {
        return this._http.delete<any>(environment.apiEndpoint + '/ConsumoIntegracionConfiguracion/?id=' + configuradorConsumoId);
    }

    public getAlmacenesByEtiquetadorId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    public getDenominacionesByEtiquetadorId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getConfeccionesByEtiquetadorId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/GetAllConFiltro', filters);
    }

    public getDesignacionesByEtiquetadorIdDenominacionId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Designacion/GetAllConFiltro', filters);
    }

    public getMarcasByEtiquetadorId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    // CONFIGURADOR ROYALTIES
    public getRoyalties(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Royalty/GetAllConFiltro', filters);
    }

    public getRoyalty(royaltyId){
      return this._http.get<any>(environment.apiEndpoint + '/Royalty/GetById?royaltyId=' + royaltyId);
    }

    public createRoyalty(royalty) {
      return this._http.post<any>(environment.apiEndpoint + '/Royalty', royalty);
    }

    public createRoyaltyMultiple(royalty) {
        return this._http.post<any>(environment.apiEndpoint + '/Royalty/InsertRoyaltyMultiple', royalty);
    }

    public updateRoyalty(royalty) {
      return this._http.put<any>(environment.apiEndpoint + '/Royalty', royalty);
    }

    public deleteRoyalty(royaltyId) {
      return this._http.delete<any>(environment.apiEndpoint + '/Royalty/?id=' + royaltyId);
    }

    public getEntidadControlAll() {
      return this._http.get<any>(environment.apiEndpoint + '/EntidadControl/GetAll');
    }

    public getPaisesByEntidadControl(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    public getDenominacionesByPaisEntidadControl(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getMarcasByPaisEntidadControlDeno(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }

}
